import { Controller } from 'react-hook-form';
import Input from 'src/components/Input/Input';
import { EditableCard } from './EditableCard';
import { useUserInfoForm } from '../hooks/useUserInfoForm';

interface UserInfoCardProps {
  userInfo: { first_name: string; last_name: string; email: string } | undefined;
  editMode: boolean;
  disabled: boolean;
  onEdit: () => void;
  onDone: () => void;
  onLoadingChange?: (isLoading: boolean) => void;
}

export const UserInfoCard = ({
  userInfo,
  editMode,
  disabled,
  onEdit,
  onDone,
  onLoadingChange,
}: UserInfoCardProps) => {
  const { control, trigger, submit, cancel } = useUserInfoForm(userInfo, onDone, onLoadingChange);

  return (
    <EditableCard
      title="My Info"
      formId="user-info"
      editMode={editMode}
      disabled={disabled}
      onEdit={onEdit}
      onCancel={cancel}
      onSubmit={submit}
      className="half-width flex-col"
    >
      <div className="input-container full-width">
        <Controller
          control={control}
          name="first_name"
          render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
            <Input
              type="text"
              label="First name"
              placeholder="Josh"
              invalidMessage={error?.message}
              isValid={!error?.message}
              value={value}
              onChange={onChange}
              onBlur={() => {
                onBlur();
                trigger('first_name');
              }}
              readonly={!editMode}
            />
          )}
        />
      </div>
      <div className="input-container full-width">
        <Controller
          control={control}
          name="last_name"
          render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
            <Input
              type="text"
              label="Last name"
              placeholder="Brawn"
              invalidMessage={error?.message}
              isValid={!error?.message}
              value={value}
              onChange={onChange}
              onBlur={() => {
                onBlur();
                trigger('last_name');
              }}
              readonly={!editMode}
            />
          )}
        />
      </div>
      <div className="input-container full-width">
        <Controller
          control={control}
          name="email"
          render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
            <Input
              type="email"
              label="Email address"
              placeholder="email@email.com"
              invalidMessage={error?.message}
              isValid={!error?.message}
              value={value}
              onChange={onChange}
              onBlur={() => {
                onBlur();
                trigger('email');
              }}
              readonly={!editMode}
            />
          )}
        />
      </div>
    </EditableCard>
  );
};
